import { Card } from "./ui/card";
import { hdImages } from "@/lib/hd-images";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "./ui/hover-card";
import { Media } from "./Media";

export const TrainSection = () => {
  return (
    <section className="py-24" id="train">
      <div className="container mx-auto px-6">
        <div className="eyebrow eyebrow-dot mb-4 reveal">Expert training</div>
        <h2 className="section-title mb-3 reveal">Train to your experts</h2>
        <p className="text-muted-foreground mb-12 reveal">
          Mimic your best clinicians with expert-curated exemplars and protocol alignment.
        </p>

        <div className="grid lg:grid-cols-2 gap-8 items-stretch">
          <HoverCard openDelay={300} closeDelay={100}>
            <HoverCardTrigger asChild>
              <Card className="reveal p-8 flex flex-col justify-center border-l-4 border-l-accent hover:-translate-y-2 transition-all duration-300 cursor-pointer">
                <ul className="space-y-4 text-muted-foreground">
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" />
                    <span>Local drug/airway preferences modeled</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" />
                    <span>Escalation & consult triggers captured</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" />
                    <span>Role-specific prompts (leader, compressor, recorder)</span>
                  </li>
                </ul>
              </Card>
            </HoverCardTrigger>
            <HoverCardContent className="w-80 bg-card/95 backdrop-blur-sm border-primary/20">
              <div className="space-y-2">
                <h4 className="text-sm font-semibold text-primary">Customized Training</h4>
                <p className="text-sm text-muted-foreground">
                  datasyteAI™ learns from your institution's top performers, capturing the nuances of your protocols and expert decision-making patterns.
                </p>
              </div>
            </HoverCardContent>
          </HoverCard>
          <HoverCard openDelay={300} closeDelay={100}>
            <HoverCardTrigger asChild>
              <div className="reveal overflow-hidden rounded-xl shadow-soft cursor-pointer">
                <Media
                  src={hdImages.trainExperts}
                  alt="Clinical experts reviewing exemplar resuscitation cases to train datasyteAI™"
                  className="w-full h-full object-cover min-h-[280px] hover:scale-105 transition-transform duration-500"
                  sizes="(max-width: 1024px) 100vw, 620px"
                />
              </div>
            </HoverCardTrigger>
            <HoverCardContent className="w-80 bg-card/95 backdrop-blur-sm border-primary/20">
              <div className="space-y-2">
                <h4 className="text-sm font-semibold text-primary">Expert-Curated Exemplars</h4>
                <p className="text-sm text-muted-foreground">
                  Your clinical experts review and validate AI recommendations, ensuring guidance aligns with institutional best practices and protocols.
                </p>
              </div>
            </HoverCardContent>
          </HoverCard>
        </div>
      </div>
    </section>
  );
};
